export const REQUEST_MASTER_EVENTS = "REQUEST_MASTER_EVENTS";
export const SET_MASTER_EVENTS = "SET_MASTER_EVENTS";
export const ERROR_GET_MASTER_EVENTS = "ERROR_GET_MASTER_EVENTS";

export const REQUEST_CREATE_MASTER_EVENTS = "REQUEST_CREATE_MASTER_EVENTS";
export const SUCCESS_CREATE_MASTER_EVENTS = "SUCCESS_CREATE_MASTER_EVENTS";
export const ERROR_CREATE_MASTER_EVENTS = "ERROR_CREATE_MASTER_EVENTS";

export const REQUEST_UPDATE_MASTER_EVENTS = "REQUEST_UPDATE_MASTER_EVENTS";
export const SUCCESS_UPDATE_MASTER_EVENTS = "SUCCESS_UPDATE_MASTER_EVENTS";
export const ERROR_UPDATE_MASTER_EVENTS = "ERROR_UPDATE_MASTER_EVENTS";

export const REQUEST_DELETE_MASTER_EVENTS = "REQUEST_DELETE_MASTER_EVENTS";
export const SUCCESS_DELETE_MASTER_EVENTS = "SUCCESS_DELETE_MASTER_EVENTS";
export const ERROR_DELETE_MASTER_EVENTS = "ERROR_DELETE_MASTER_EVENTS";

export const SET_MESSAGE_MASTER_EVENTS = "SET_MESSAGE_MASTER_EVENTS";